module.exports = __webpack_public_path__ + "static/media/54799924_2519308764810966_1752421994789339136_o.ccd9843a.jpg";